export default class DateHelper {
    static getEstimatedMonth({ estimatedDate, locale, shouldRoundUpMonth }) {
        const date = new Date(estimatedDate);
        if (date instanceof Date) {
            let YY = date.getFullYear();
            let MM = date.getMonth();
            const DD = date.getDate();
            const daysToRound = 10;
            const DDInMonth = new Date(YY, MM + 1, 0).getDate();
            const isDateWithinDaysToRound = DD > (DDInMonth - daysToRound);

            if (isDateWithinDaysToRound && shouldRoundUpMonth) {
                if (MM === 11) {
                    MM = 0;
                    YY += 1;
                } else {
                    MM += 1;
                }
            }

            const monthName = new Intl.DateTimeFormat(locale, { month: 'long' }).format(new Date(YY, MM, 1));
            return `${monthName} ${YY}`;
        }
        return '';
    }

    static getDateRoundedUp({
        date, locale, daysToRound, dateTimeFormatOptions,
    }) {
        const formattedDate = new Date(date);
        if (!date || !(formattedDate instanceof Date)) {
            return '';
        }

        formattedDate.setDate(formattedDate.getDate() + daysToRound);

        return new Intl.DateTimeFormat(locale, dateTimeFormatOptions).format(formattedDate);
    }

    static getFormattedDate({
        date, locale, dateTimeFormatOptions,
    }) {
        const formattedDate = new Date(date);
        if (!date || !(formattedDate instanceof Date)) {
            return '';
        }

        return new Intl.DateTimeFormat(locale, dateTimeFormatOptions).format(formattedDate);
    }

    static isDateAfterDaysFromToday({ date, days }) {
        if (!date) { return false; }
        const d1 = new Date(date);
        const d2 = new Date();
        d2.setDate(d2.getDate() + (days ?? 0));
        return d1 > d2;
    }
}
